export default {
  cleanHubData: state => state.cleanHubData,
  hubData: state => state.hubData,
  connectedDevices: state => state.connectedDevices,
  requests: state => state.requests,
  tools: state => state.tools,
  shopDevices: state => state.shopDevices,
  techs: state => state.techs,
  statisticInterval: state => state.statisticInterval,
  serviceRequest: state => state.serviceRequest,
  waitingChats: state => state.waitingChats
}



// WEBPACK FOOTER //
// ./src/store/modules/astechhub/getters.js